import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { DialogService } from '@hyperkit'

import { CalendlyService } from '../../services/calendly.service'
import { UserService } from '../../services/user.service'

@Component({
  standalone: false,
  selector: 'contact-cyborg',
  templateUrl: './contact-cyborg.component.html',
  styleUrls: ['./contact-cyborg.component.scss'],
})
export class ContactCyborgComponent implements OnInit {
  private userService = inject(UserService)
  dialog = inject(DialogService)
  calendlyService = inject(CalendlyService)

  private destroyRef = inject(DestroyRef)

  public profile$ = this.userService.profile$

  // Derived observable for trial status
  public trial$: Observable<boolean> = this.profile$.pipe(
    map((profile) => profile?.company.status === 'trial'),
  )

  public ngOnInit(): void {
    // Load profile once
    this.userService
      .loadProfile()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: (err) => console.error('Failed to load profile:', err),
      })
  }

  public contactCyborg(): void {
    this.calendlyService.talkToCyborg()
  }
}
